const environment = {
	lang: 'pt-BR',
	csEmail: 'suporte@aceleradordoingles.com.br',
};

export default environment;
